angular.module('impactx.clientcompany').controller('ClientCompanyListCtrl', [
    ClientCompanyListController]);

function ClientCompanyListController() {
    var self = this;

    self.meta = {
        rowTemplate: 'modules/clientcompany/templates/client-company-list.row.tmpl.html',
        isSelectAble: false,
        ctrl: this,
        endpoint: '/company/client/list',
        id: "clientcompanylist",
    };

    self.getMeta = function () {
        return this.meta;
    };
}